import React from 'react';
import {
    Grid,
    Typography,
    TextField,
    Button,
    DialogContent,
    MenuItem,
    FormHelperText,
} from '@mui/material';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import DraggableDialog from '../../../ui/draggableDialog';
import { toast } from 'react-toastify';
import { isLocalDev } from '../../../../utils/environment';
import { initialValuesEncounter, validationSchemaValidEncounter, } from '../validDataFormValidationSchema';
import { ValidDataService } from '../../../../service/validDataService';

export default function editValidEncounterForm({ open, onClose, onRecordEdit, validOrder }) {

    const handleSubmit = async (values, { resetForm }) => {
        try {
            const response = await ValidDataService.addValidEncounter({ ...values });
            const { code, data, message } = response;
            if (code === 0) {
                toast.success(message);
                onClose();
                onRecordEdit(data);
            } else {
                toast.error(message);
            }
        } catch (error) {
            if (isLocalDev) {
                console.log(error);
            }
            toast.error('Failed to update record');
        }
    };

    return (
        <DraggableDialog title={"Edit Services"} onClose={onClose} open={open} width={'md'}>
            <DialogContent>
                <Formik
                    initialValues={{ ...initialValuesEncounter, ...validOrder }}
                    validationSchema={validationSchemaValidEncounter}
                    onSubmit={handleSubmit}
                >
                    {({ values, setFieldValue, isSubmitting, touched, isValid }) => (
                        <Form>

                            <Grid container spacing={2} sx={{ mt: 1, mb: 1 }}>
                                <Grid item xs={12} md={4}>
                                    <Field
                                        as={TextField}
                                        name='name'
                                        label="Name"
                                        required
                                        fullWidth
                                    />
                                    <ErrorMessage name='name'>{message => <Typography color={'red'}>{message}</Typography>}</ErrorMessage>
                                </Grid>
                                <Grid item xs={12} md={1}>
                                    <Field
                                        as={TextField}
                                        name='duration'
                                        label="Duration (min)"
                                        required
                                        fullWidth
                                    />
                                    <ErrorMessage name='cost'>{message => <Typography color={'red'}>{message}</Typography>}</ErrorMessage>
                                    <FormHelperText sx={{
                                        display: { sm: 'none', lg: 'block' },
                                    }}>minutes</FormHelperText>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Field
                                        as={TextField}
                                        name='notes'
                                        label="Notes"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <Field
                                        as={TextField}
                                        name='status'
                                        label="Status"
                                        select
                                        required
                                        fullWidth
                                    >
                                        <MenuItem value={"active"}>Active</MenuItem>
                                        <MenuItem value={"inactive"}>Inactive</MenuItem>
                                    </Field>
                                </Grid>
                            </Grid>
                            {
                                isSubmitting ? 'Saving...' : <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    disabled={!isValid}
                                >
                                    Save
                                </Button>
                            }
                        </Form>
                    )}
                </Formik>
            </DialogContent>
        </DraggableDialog >
    );
};